import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  socketData: null,
  messageType: '',
};

export const sliceKey = 'socket';

export const socketSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    setSocketData: (state, { payload }) => {
      try {
        state.socketData = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setSocketMessageType: (state, { payload }) => {
      try {
        state.messageType = payload;
      } catch (e) {
        console.log(e);
      }
    },
  },
});

export const { setSocketData, setSocketMessageType } = socketSlice.actions;

export default socketSlice.reducer;
